/**
 * Full-screen error state for ProjectProvider's initial load.
 *
 * Only rendered once the bounded auto-retry (see ProjectContext.tsx) has
 * been exhausted AND we have no usable project list yet — a transient blip
 * self-recovers before this ever appears. Gives the user a real "Retry"
 * action instead of the old hardcoded "Please refresh the page." toast,
 * which ignored the actual error and left the app stuck even after a
 * manual reload if the underlying condition (e.g. a 429) hadn't cleared.
 */
import './ProjectLoadError.css'

export interface ProjectLoadErrorProps {
  message: string
  onRetry: () => void
}

export function ProjectLoadError({ message, onRetry }: ProjectLoadErrorProps) {
  return (
    <div className="project-load-error" data-testid="project-load-error">
      <div className="project-load-error__card">
        <div className="project-load-error__icon" aria-hidden="true">
          ⚠️
        </div>
        <p className="project-load-error__title">Couldn&apos;t load projects</p>
        <p className="project-load-error__message" data-testid="project-load-error-message">
          {message}
        </p>
        <button
          type="button"
          className="project-load-error__retry-btn"
          onClick={onRetry}
          data-testid="project-load-retry-btn"
        >
          Retry
        </button>
      </div>
    </div>
  )
}

export default ProjectLoadError
